import { Component, ViewChild,Inject, LOCALE_ID } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { distinctUntilChanged } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common';
import { CookieModalComponent } from 'src/app/shared/components/cookie-modal/cookie-modal.component';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { DeviceDetectorService } from 'ngx-device-detector';
import { fontLocale } from './config/locale-font';
import { AdobeAnalyticsService } from './shared/services/common/adobeAnalytics.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  modalref: BsModalRef;
  title = 'Mastercard';
  isDetailsPage = false;
  pathname = '';
  public fontLocale = fontLocale

  @ViewChild('sidenav') sidenav;
  constructor(
    private router: Router,
    private modalService: BsModalService,
    private deviceService: DeviceDetectorService,
    @Inject(DOCUMENT) private document: any,
    @Inject(LOCALE_ID) private locale: string,
    private adobeAnalyticsService: AdobeAnalyticsService
  ) {
    try {
      this.router.events.pipe(
            distinctUntilChanged((previous: any, current: any) => {
                if (current instanceof NavigationEnd) {
                    return previous.url === current.url;
                }
                return true;
            })).subscribe((x: any) => {
              if (window['reloadOTBanner']) {
                window['reloadOTBanner']();
              }
              this.changeOfRoutes();
            }
    );
    this.deregisterServiceWorker();
    } catch (error) {
      console.error('Error in AppComponent constructor', error);
    }
  }
  deviceInfo;
  ngOnInit() {
    if (this.fontLocale[this.locale]) {
      const styles = `
        @font-face {
          font-family: ${this.fontLocale[this.locale]?.name};
          src: url(${this.fontLocale[this.locale]?.url}) format('woff');
        }
        body {
          font-family: ${this.fontLocale[this.locale]?.name}, sans-serif !important;
        }
      `;
      const node = document.createElement("style");
      node.innerHTML = styles;
      node.id = 'locale-font'
      document.body.appendChild(node);
    }
    if (!localStorage.getItem("cookiePolicy")) {
      // this.showCookie(true);
    }
    this.deviceInfo = this.deviceService.getDeviceInfo();
  }

  changeOfRoutes(){
    this.isDetailsPage = this.document.location.pathname.includes("offers/details") ? true : false;
    if(localStorage.getItem("firstLoad")){
      localStorage.removeItem('firstLoad');
    }
    this.pathname = this.document.location.pathname.replace('/','').split('/').join('--');
    
    // Reset data layer flag on route change to allow new data layer creation
    this.adobeAnalyticsService.resetDataLayerFlag();
  }

  showCookie(ignoreBackdropClick = false){
    var config = {
      backdrop: true,
      ignoreBackdropClick: ignoreBackdropClick,
      class: 'cookie-modal modal-lg'
    };
    this.modalref = this.modalService.show(CookieModalComponent, Object.assign({}, config, { }));
    this.modalref.content.hideEvent.subscribe(res => {
      this.modalref.hide();
    })
  }
  private deregisterServiceWorker() {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .getRegistrations()
        .then((registrations) => {
          console.log('registrations to unregister', registrations)
          for (const registration of registrations) {
            registration.unregister()
          }
        })
        .catch(function (err) {
          console.log('Service Worker registration failed: ', err)
        })
    }
  }
}
